module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/philosophy01_sp-732170c1bf415a60df66d1520c928819.png";